import { render, staticRenderFns } from "./QuestionListItemInput.vue?vue&type=template&id=1320f0cc&scoped=true&"
import script from "./QuestionListItemInput.vue?vue&type=script&lang=ts&"
export * from "./QuestionListItemInput.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionListItemInput.vue?vue&type=style&index=0&id=1320f0cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1320f0cc",
  null
  
)

export default component.exports